import { TableOutlined } from "@ant-design/icons";
import { Skeleton, Tooltip } from "antd";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import PanelCard from "../../../Pages/DashboardPage/components/PanelCard";
import "./AreaCode.scss";

const CodesTable = ({ data, loading }) => {
  const transformedData = !loading
    ? Object.entries(data || {}).map(([bankName, areaCodeArray], index) => ({
        key: index,
        bank_name: bankName,
        area_codes: areaCodeArray.map((item) => ({
          areacode: item.area_code,
          status: item.status,
        })),
      }))
    : [];

  const columns = [
    {
      title: "Bank Name",
      dataIndex: "bank_name",
      key: "bank_name",
      render: (bankName) =>
        loading ? <Skeleton.Input size="small" active /> : bankName ?? "N/A",
    },
 {
  title: "Pin Codes",
  dataIndex: "area_codes",
  key: "area_codes",
  render: (area_codes) => {
    if (loading) {
      return <Skeleton.Input size="small" active />;
    }

    const codes =
      area_codes?.map((item) => item?.areacode).filter(Boolean) || [];

    if (!codes.length) return "N/A";

    const visible = codes.slice(0, 3);
    const hidden = codes.slice(3);

    return (
      <span className="areacode-cell">
        {visible.map((code) => (
          <span className="areacode-chip" key={code}>
            {code}
          </span>
        ))}
        {hidden.length > 0 && (
          <Tooltip title={hidden.join(", ")}>
            <span className="areacode-chip areacode-chip--more">
              +{hidden.length} more
            </span>
          </Tooltip>
        )}
      </span>
    );
  },
}

  ];

  return (
    <PanelCard
      title="Area Codes"
      icon={<TableOutlined />}
      accent="blue"
      padded={false}
    >
      <div className="codes_table_container">
        <ReusableTable
          columns={columns}
          dataSource={loading ? Array(4).fill(0) : transformedData}
          rowKey="key"
          pageSize={10}
          CurrentPageNo={1}
          totalItems={transformedData?.length}
        />
      </div>
    </PanelCard>
  );
};

export default CodesTable;
